<app-left-right-frame
  size="0"
  [isMinimal]="true"
  [isLeftDisabled]="!(points < 5 && valueLevel > 0)"
  [isRightDisabled]="!(points > 0)"
  (leftClick)="down.emit(valueName)"
  (rightClick)="up.emit(valueName)">
  {{ value + valueLevel }}
</app-left-right-frame>
